import React, { FC } from 'react';
import './Preloader.css';

const Preloader: FC<
  React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>
> = ({ ...props }) => {
  return <div {...props} className="mh-preloader" />;
};
export default Preloader;
